//deps
import React, { memo } from "react";

//internal-deps
import { TURBO_PAYMENT_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";

//styles
import {
    BlockContent,
    Col,
    FixedBottomBlock,
    Line,
    Row,
    PaymentMethodLine,
    PayButton,
    PaymentMethodIcon,
} from "./styles/TurboPaymentWidgetShimmer.style";

const SHIMMER_DIMENSIONS = {
    ICON_HEIGHT: 12,
    ICON_WIDTH: 10,
    METHOD_HEIGHT: 12,
    METHOD_WIDTH: 40,
    LINE_HEIGHT: 15,
    LINE_WIDTH: 65,
    PAY_HEIGHT: 52,
    PAY_WIDTH: 100,
};

const TurboPaymentWidgetShimmer = () => {
    return (
        <FixedBottomBlock data-testid={TURBO_PAYMENT_WIDGET_DATA_TEST_IDS.SHIMMER}>
            <BlockContent>
                <Row>
                    <Col>
                        <Row>
                            <PaymentMethodIcon
                                height={SHIMMER_DIMENSIONS.ICON_HEIGHT}
                                width={SHIMMER_DIMENSIONS.ICON_WIDTH}
                            />
                            <PaymentMethodLine
                                height={SHIMMER_DIMENSIONS.METHOD_HEIGHT}
                                width={SHIMMER_DIMENSIONS.METHOD_WIDTH}
                            />
                        </Row>
                        <Line height={SHIMMER_DIMENSIONS.LINE_HEIGHT} width={SHIMMER_DIMENSIONS.LINE_WIDTH} />
                    </Col>

                    <Col>
                        <PayButton width={SHIMMER_DIMENSIONS.PAY_WIDTH} height={SHIMMER_DIMENSIONS.PAY_HEIGHT} />
                    </Col>
                </Row>
            </BlockContent>
        </FixedBottomBlock>
    );
};

export default memo(TurboPaymentWidgetShimmer);
